import React, {Component} from 'react';
import Globals from '../Globals';

var lodash = require('lodash')

class FormSocieteSiteAppelSortant extends Component {

  constructor(props) {
    super(props);

    this.state = {
      marques: [],
      societes: [],
      sites: [],
      _plaques: [],
      current_type : '',
      presel : false,
      userSites: [],
    }
  }

  componentWillMount() {
    if(this.props.origin === "CallWin")
      this.fetchSocietesSites();
    else 
      this.fetchUserSocietesSites();
  }

  componentDidUpdate(prevProps, prevState){
      if (prevProps.typeActive !== this.props.typeActive){
         this.fetchAffectedSocieteSite();
      }
   }

  fetchUserSocietesSites(){
    fetch(localStorage.ClientApiURL + '/Utilisateurs/'+localStorage.user_IDUtilisateur, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'APIKey': Globals.API_KEY,
        'IDClient': localStorage.user_IDClient,
        'Login': localStorage.user_login,
        'Password': localStorage.user_password
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then(json => {
      this.setState({
        userSites: lodash.map(json.Sites, 'IDSite'),
      }, this.fetchSocietesSites);
    })
    .catch((error) => {
        console.log(error)
    });
  }
   
  fetchAffectedSocieteSite(){
    var societe_aff = this.props.prospect.SiteAffectation.Plaque.IDPlaque;
    var site_aff = this.props.prospect.SiteAffectation.IDSite;
    var correct_type = false;

    var index_societe = lodash.findIndex(this.state._plaques, ['IDPlaque',societe_aff]);
    var index_site = lodash.findIndex(this.state._plaques[index_societe].Sites, ['IDSite',site_aff]);
    if((this.props.typeActive == "VN" && this.state._plaques[index_societe].Sites[index_site].EstVN)
    || (this.props.typeActive == "VO" && this.state._plaques[index_societe].Sites[index_site].EstVO)){
      correct_type = true;
    }
    this.props.onChangeValue('societe', correct_type ? societe_aff : 0);
    this.props.onChangeValue('site', correct_type ? site_aff : 0);
  }

  fetchSocietesSites() {
    fetch(localStorage.ClientApiURL + '/Plaques', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'APIKey': Globals.API_KEY,
        'IDClient': localStorage.user_IDClient,
        'Login': localStorage.user_login,
        'Password': localStorage.user_password
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    })
    .then(json => {
      var societes = [];
      var sites = [];

      var marques = [];

      lodash.map(json, (plaque) => {
        var sites = lodash.filter(plaque.Sites, (site) => {
          return site.Est_eSellerLeadActif === true 
            && ((this.props.typeActive === "VO" && site.EstVO === true) || (this.props.typeActive === "VN" && site.EstVN === true))
            && (this.props.origin === "CallWin" || this.state.userSites.indexOf(site.IDSite) !== -1);
        });

        if (!sites.length) {
          return;
        }

        plaque.Sites.map((site) => {
          return site.Marques.map((marque) => {
            marques.push(marque.Description);
            return marque;
          });
        });

        return;
      });

      marques = lodash.uniq(marques).sort();

      json.map((plaque) => {
        return societes[plaque.IDPlaque] = plaque.Nom;
      })

      json.map((plaque) => {
        var index = societes.indexOf(plaque.Nom);
        sites[index] = [];
        return plaque.Sites.map((site) => {
          //récupération des sites actifs, Libelle s'il existe, et VN/VO pour affichage
          if(site.Est_eSellerLeadActif === true 
            && (this.props.origin === "CallWin" || this.state.userSites.indexOf(site.IDSite) !== -1)
            && ( (this.props.typeActive === "Atelier") || (this.props.typeActive === "VO" && site.EstVO === true ) || (this.props.typeActive === "VN" && site.EstVN === true) ) ){
              sites[index][site.IDSite] = site.Libelle ? site.Libelle : site.Nom;
          }
          return site;
        })
      })
      this.setState({
        marques: marques,
        societes: societes,
        sites: sites,
        _plaques: json,
      });
      this.fetchAffectedSocieteSite();
    })
    .catch((error) => {
      console.log(error)
    });
  }
  handleClickCanal(event) {
    this.props.onChangeValue('canal', event.target.value);
  }

  handleChangeSociete(event) {
    this.props.onChangeValue('societe', event.target.value ? event.target.value : 0);
    this.props.onChangeValue('site', 0);
    this.props.onChangeValue('todoToVendeur', false);
  }

  handleChangeSite(event) {

    var societe = 0;

    if (event.target.value) {
      this.state._plaques.map((plaque) => {
        return plaque.Sites.map((site) => {
          if (parseInt(site.IDSite, 10) === parseInt(event.target.value, 10)) {
            societe = plaque.IDPlaque;
          }
          return site;
        })
      })
    }

    this.props.onChangeValue('societe', societe);
    this.props.onChangeValue('site', event.target.value ? event.target.value : 0);
    this.props.onChangeValue('todoToVendeur', false);
  }

  generateAll(){
    this.fetchSocietesSites();
  }

  handleChangeMarque(event) {
    this.props.onChangeValue('marque', event.target.value);
    this.props.onChangeValue('societe', 0);
    this.props.onChangeValue('site', 0);
  }

  render() {
    return (
      <div style={{ marginBottom: '55px' }}>
        <h3>Société / Site</h3>
        <div className="form-group">
          <div className="col-md-8 col-md-offset-2">
            <select className="form-control" onChange={this.handleChangeSociete.bind(this)} id="leadSociete" name="leadSociete" value={this.props.societe} required="required">
              <option key="0">Société</option>
              {this.state._plaques.map((societe, id) => {
                var sites_by_type = societe.Sites.filter((site) => {
                  return (this.props.origin === "CallWin" || this.state.userSites.indexOf(site.IDSite) !== -1) && ((site.EstVN && this.props.typeActive === "VN") || (site.EstVO && this.props.typeActive === "VO"));
                })
                if(!sites_by_type.length) {
                  return null;
                }
                return <option key={societe.IDPlaque} value={societe.IDPlaque}>{ societe.Nom }</option>;
              })}
            </select>
          </div>
        </div>

        {this.props.societe && this.props.societe !== "Société" ?
          <div className="form-group">
            <div className="col-md-8 col-md-offset-2">
              <select className="form-control" onChange={this.handleChangeSite.bind(this)} id="leadSite" name="leadSite" value={this.props.site} required="required">
                <option value="" key="0">Site</option>
                {this.state._plaques.map((societe, id) => {
                  if (parseInt(societe.IDPlaque, 10) === parseInt(this.props.societe, 10)) {
                    return societe.Sites.map((site) => {
                      if(this.props.origin === "CallWin" || this.state.userSites.indexOf(site.IDSite) !== -1)
                        return <option key={site.IDSite} value={site.IDSite} >{ site.Libelle ? site.Libelle : site.Nom }</option>;
                    })
                  }
                  return null;
                })}
              </select>
            </div>
          </div>
        : null }

      </div>
    );
  }
}

export default FormSocieteSiteAppelSortant;
